import React, { useContext, useState } from "react";
import styled from "styled-components";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import Input from "../UI/Form/Input";
import Select from "react-select";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  padding: 1em;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
`;

const Button = styled.div`
  display: flex;
  background-color: #202731;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  cursor: pointer;
  :hover {
    background-color: #db0a41;
  }
`;

const SelectContainer = styled(Select)`
  min-width: 200px;
  margin-bottom: 0.5em;
  width: 60%;
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
  }),
  option: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    "&:hover": {
      color: "#db0a41",
    },
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};

const VAR_DECISIONS = [
  "Decision Overturned",
  "Penalty Awarded",
  "Goal Awarded",
  "Offside",
  "Decision Upheld",
  "Custom",
];

export default function Extras({ game }) {
  const { previewGraphic } = useContext(GraphicsContext);
  const [decision, setDecision] = useState(VAR_DECISIONS[0]);
  const [customDecision, setCustomDecision] = useState("");
  const [topline, setTopline] = useState("");
  const [bottomline, setBottomline] = useState("");

  return (
    <Main>
      <ActionPanel>
        <Row>
          <SelectContainer
            styles={DropdownStyles}
            value={{ value: decision, label: decision }}
            options={VAR_DECISIONS.map((d) => ({ value: d, label: d }))}
            onChange={(e) => setDecision(e.value)}
          />
          {decision === "Custom" && (
            <Input
              value={customDecision}
              placeholder="Custom decision"
              onChange={(e) => setCustomDecision(e.target.value)}
            />
          )}
          <Button
            onClick={() => {
              previewGraphic("VAR", {
                decision: decision === "Custom" ? customDecision : decision,
                game,
              });
            }}
          >
            VAR
          </Button>
        </Row>
      </ActionPanel>
      <ActionPanel>
        <Row>
          <Input
            title="Top Line"
            value={topline}
            onChange={(e) => setTopline(e.target.value)}
          />
          <Input
            title="Bottom Line"
            value={bottomline}
            onChange={(e) => setBottomline(e.target.value)}
          />
          <Button
            onClick={() => {
              previewGraphic("ClockInformation", {
                topline,
                bottomline,
                game,
              });
            }}
          >
            Clock Information
          </Button>
        </Row>
      </ActionPanel>
    </Main>
  );
}
